module.exports = __webpack_public_path__ + "img/AT0000001221819.558157ca.png";